(function () {
  'use strict';

  var root = document.querySelector('[data-field-note]');
  var testKeys = ['field_note_test', 'oak_release_test', 'preview_theme_id'];
  var pathMeasurementId = 'G-QDH0E1G2RS';
  var params = new URLSearchParams(window.location.search);
  var releaseTest = testKeys.some(function (key) {
    return params.has(key);
  });
  var emit = function (eventName, context, detail) {
    var payload = Object.assign({}, context, detail || {});
    payload.send_to = pathMeasurementId;
    payload.transport_type = 'beacon';
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
  };

  if (root && root.dataset.analyticsInitialized !== 'true') {
    root.dataset.analyticsInitialized = 'true';
    releaseTest = (
      root.dataset.designMode === 'true' ||
      releaseTest
    );
    var context = {
      note_handle: root.dataset.noteHandle || '',
      source_post_id: root.dataset.sourcePostId || '',
      asc_identifier: root.dataset.ascId || '',
      topic: root.dataset.noteTopic || '',
      taxon_or_cultivar: root.dataset.noteCultivar || root.dataset.noteTaxon || '',
      source_surface: 'standalone_field_note',
      publication_batch: root.dataset.publicationBatch || '',
      osn_test_traffic: releaseTest ? 'release_verification' : 'none'
    };

    if (root.dataset.viewTracked !== 'true') {
      root.dataset.viewTracked = 'true';
      emit('field_note_view', context);
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (!link || !root.contains(link)) return;

      var action = link.dataset.fieldNoteAction;
      if (action === 'image') {
        emit('field_note_image_open', context, {
          image_index: Number(link.dataset.imageIndex || 0)
        });
        return;
      }

      if (action === 'related') {
        emit('field_note_related_click', context, {
          destination_note_handle: link.dataset.destinationNote || ''
        });
        return;
      }

      if (action === 'guide') {
        emit('field_note_guide_click', context, {
          destination_guide_handle: link.dataset.destinationGuide || ''
        });
        return;
      }

      var productCard = link.closest('[data-field-note-product]');
      if (productCard) {
        emit('field_note_product_click', context, {
          destination_product_handle: productCard.dataset.productHandle || ''
        });
      }
    });
  }

  if (document.documentElement.dataset.productFieldNoteAnalytics !== 'true') {
    document.documentElement.dataset.productFieldNoteAnalytics = 'true';
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-product-field-note]');
      if (!link) return;
      emit('product_field_note_click', {
        note_handle: link.dataset.noteHandle || '',
        source_post_id: link.dataset.sourcePostId || '',
        source_product_handle: link.dataset.sourceProductHandle || '',
        source_surface: 'product_field_notes',
        publication_batch: link.dataset.publicationBatch || '',
        osn_test_traffic: releaseTest ? 'release_verification' : 'none'
      });
    });
  }
})();
